export default __webpack_public_path__ + "static/media/quiz-page.c1b09b55.png";